import { checkAccess } from 'app/actions/app.actions';
import { fetchRetailerDetails } from 'utils/actions/utils.actions';
import { setType } from 'retailer-dashboards/actions/retailer-dashboards.actions';

import fetchRetailerId from 'retailer-dashboards/resources/retailer-dashboards-api';

import RetailerDashboardsSearchPageTemplate from './retailer-dashboards-search-page.html';

const mapStateToThis = (state) => {
  const { session, retailerDetails } = state;
  const { lotteryRepresentatives } = session;

  return {
    lotteryRepresentatives,
    retailerDetails,
  };
};

const mapDispatchToThis = {
  fetchRetailerDetails,
  checkAccess,
  setType,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', '$state', 'ErrorNotificationService')
class RetailerDashboardsSearchPageController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.fetchRetailerId = fetchRetailerId;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async search(form) {
    form.$setSubmitted();
    if (form.$invalid) {
      return;
    }

    if (!this.checkAccessToRetailer()) {
      const message = {
        title: this.gettextCatalog.getString('Retailer access not allowed.'),
      };
      return this.ErrorNotificationService.showMessage(message);
    }

    const retailerId = await this.fetchRetailerId(this.retailerDisplayNumber);

    await this.fetchRetailerDetails(retailerId);

    this.setType(this.retailerDetails.retailerType);
    this.$state.go('retailerWidgets-view-dashboard', { retailerNo: retailerId });
  }

  checkAccessToRetailer() {
    if (
      this.checkAccess('retailerWidgets.view.limitToRetailers') &&
      this.lotteryRepresentatives &&
      this.lotteryRepresentatives.length > 0
    ) {
      return this.lotteryRepresentatives.find((representative) => representative.retailerId === this.retailerDisplayNumber * 1);
    }
    return true;
  }
}

class RetailerDashboardsSearchPageComponent {
  constructor() {
    this.template = RetailerDashboardsSearchPageTemplate;
    this.controller = RetailerDashboardsSearchPageController;
    return this;
  }
}

export default RetailerDashboardsSearchPageComponent;



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/containers/search-page/retailer-dashboards-search-page-component.js